const normalizeToolFunctionName = name => {
  const value = String(name || '')
  const slash = value.split('/').filter(Boolean).pop() || value
  return slash.split('.').filter(Boolean).pop() || slash
}

const TOOL_ARGUMENT_PREVIEW_LIMIT = 80

const toolArgumentText = value => {
  if (typeof value === 'string') return value
  if (value === undefined) return ''
  try {
    return JSON.stringify(value)
  } catch (err) {
    return String(value)
  }
}

const ellipsizeToolArgument = value => {
  if (value.length <= TOOL_ARGUMENT_PREVIEW_LIMIT) return value
  return `${value.slice(0, TOOL_ARGUMENT_PREVIEW_LIMIT - 1)}…`
}

const parsedToolArgumentPreview = args => {
  if (typeof args !== 'string' || !args.trim()) return ''
  let parsed
  try {
    parsed = JSON.parse(args)
  } catch (err) {
    return ''
  }
  const values = parsed && typeof parsed === 'object'
    ? Object.values(parsed)
    : [parsed]
  if (!values.length) return ''

  const first = ellipsizeToolArgument(toolArgumentText(values[0]))
  if (first.length >= TOOL_ARGUMENT_PREVIEW_LIMIT) return first
  let preview = first
  for (const value of values.slice(1)) {
    const text = toolArgumentText(value)
    if (!text) continue
    const candidate = preview ? `${preview} ${text}` : text
    if (candidate.length > TOOL_ARGUMENT_PREVIEW_LIMIT) break
    preview = candidate
  }
  return preview
}

const toolCallPreview = toolCall => {
  const fn = toolCall && toolCall.function || {}
  const name = normalizeToolFunctionName(fn.name) || 'tool'
  const args = parsedToolArgumentPreview(fn.arguments)
  return args ? `${name} ${args}` : name
}

const toolCallsForAssistant = event => (
  Array.isArray(event && event.message && event.message.tool_calls)
    ? event.message.tool_calls.filter(call => call && call.id)
    : []
)

const userRow = user => ({
  id: user.id,
  kind: 'user',
  user,
  sourceMessage: user,
  preview: user.message && user.message.content
})

const toolCallRow = (assistant, toolCall) => ({
  id: `${assistant.id}::tool-call::${toolCall.id}`,
  kind: 'tool-call',
  assistant,
  sourceMessage: assistant,
  toolCall,
  preview: toolCallPreview(toolCall)
})

const messagesViewRows = transcript => {
  const rows = []
  const rowsByUserId = new Map()
  let lastRow
  for (const message of transcript || []) {
    if (!message || !message.message) continue
    if (message.message.role === 'user') {
      lastRow = userRow(message)
      rows.push(lastRow)
      if (message.id) rowsByUserId.set(message.id, lastRow)
      continue
    }
    if (message.message.role !== 'assistant') continue
    const row = rowsByUserId.get(message.turnId) ||
      rowsByUserId.get(message.inReplyTo) ||
      lastRow
    if (row) row.assistant = message
    for (const toolCall of toolCallsForAssistant(message)) {
      rows.push(toolCallRow(message, toolCall))
    }
  }
  return rows
}

module.exports = {
  messagesViewRows,
  parsedToolArgumentPreview,
  toolCallPreview,
  toolCallsForAssistant
}
